import { createFileRoute, redirect } from "@tanstack/react-router"
import { ChangeProjectActions } from "@/features/change-projects/components/ChangeProjectActions"
import { canManageBulkUpdates } from "@/features/change-projects/core/access"

export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId/define")({
  beforeLoad: ({ context, params }) => {
    if (!canManageBulkUpdates(context.user)) {
      throw redirect({
        to: "/bulk-updates/$changeProjectId/review",
        params: { changeProjectId: params.changeProjectId },
        replace: true,
      })
    }
  },
  component: DefineStep,
})

function DefineStep() {
  const { changeProjectId } = Route.useParams()
  return <ChangeProjectActions changeProjectId={changeProjectId} />
}
